import i18n from "../i18n";

export const formatDaysToRetirement = (daysToRetirement) => {
  if (daysToRetirement === 0) {
    return i18n.t("Your account is about to be retired today");
  } else if (daysToRetirement === 1) {
    return i18n.t("Your account is about to be retired tomorrow");
  } else if (daysToRetirement > 1) {
    return i18n.t("Your account is about to be retired in " + daysToRetirement + " days");
  }

  return i18n.t("Your account is about to be retired");
};
